import { Injectable, Inject } from '@angular/core';
import { ActivatedRoute, Router, NavigationStart, RoutesRecognized, NavigationEnd } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';


@Injectable()
/**
 * 
 * ==기본 로직==
 * 1.리스트 URL /notice/list 에서 `list` 삭제
 * 2./notice/ 와 다음페이지 URL '다음페이지 URL'.indexOf('/notice/') 비교
 *  상세인 경우
 *  예: /notice/some_url
 *  !저장!
 *  아닌경우
 *  !초기화!
 * 3.상세에서 리스트로 복귀 시
 *  리스트 ngOnInit() 에서 
 *  !복구!
 * ===========
 * 
 * ==사용법==
 * export class 리스트Component {
 *      constructor(private restore: Restore) {
 *      }
 *      
 *      ngOnInit() {
 *          if(this.restore.restore(this)) return; // 최 상단
 *      }
 * 
 *      ngOnDestroy() {
 *          this.restore.save(this);
 *      }
 * }
 * =========
 * 
 * 
 */
export class Restore {

    //private router: Router;
    //private route: ActivatedRoute;
    static readonly Refresh_Param_Key='refresh';
    private history = this.resetHistory();
    private components: Array<ComponentByUrl> = new Array<ComponentByUrl>();

    constructor(private router: Router, private route: ActivatedRoute) {
        //히스토리 저장
        router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(({urlAfterRedirects}: NavigationEnd) => {
            this.history = [...this.history, this.getCleanUrl(urlAfterRedirects)];
      });

      //전혀 다른 페이지 진입 시 초기화
      router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe((ev: NavigationEnd) => {
          console.log(ev);
          let url = this.getCleanUrl(ev.url);
          if(this.components.filter(o => o.url==url).length<1) {
              this.clear();
          }
      })
    }

    /**
     * @description 컴포넌트.ts 내 모든 데이터 저장 , 리스트 페이지 ngOnDestroy 에서 호출 필요
     */
    /*
        주의 사항
        this.router.url ngOnDestroy 에서 호출되기 때문에 ngOnDestroy가 호출된 URL 이 `아닌` *다음페이지 URL 이 리턴된다.*
        this.history[this.history.length-1] ngOnDestroy 가 호출된 URL
    */
    public save(_this: any): void {

        if(!this.isGoToDetail()) {
            this.clear();
            return;
        }

        this.add(this.history[this.history.length-1], _this);
        console.log("Restore!저장!", _this);
    }

    /**
     * @description 복구 , ngOnInit 최 상단에서 호출 필요
     */
    public restore(_this: any): boolean {
        let url = this.getCleanUrl(this.router.url);
        
        this.resetHistory();

        if(this.route.snapshot.queryParams.hasOwnProperty(Restore.Refresh_Param_Key)) {
            let params =Object.assign(new Object(), this.route.snapshot.queryParams);
            delete params[Restore.Refresh_Param_Key];
            console.log(params);
            this.router.navigate([url], { relativeTo: this.route, queryParams: params});
            this.clear();
            return false;
        }

        if(!this.get(url)) {
            this.clear();
            return false;
        }

        let component = this.get(url);
        for(let key in component._this) {
            _this[key]=component._this[key];
        }
        setTimeout(() => {
            window.scroll(0,component.scroll)
        }, 50);
        console.log("!복구!");
        this.clear();
        return true;
    }

    /**
     * @description 현재 들어있는 컴포넌트들을 가져옴
     */
    public getAll(): Array<ComponentByUrl> {
        return this.components;
    }

    private get(url: string): ComponentByUrl {
        url = this.getCleanUrl(url);

        let component: ComponentByUrl = this.components.find(o => o.url==url);
        if(!component) return null;
        else return component;
    }

    private add(url: string, _this:any): void {
        url = this.getCleanUrl(url);

        let item = new ComponentByUrl();
        item.url=url;
        item._this=_this;
        item.scroll=window.scrollY;//IOS 오류 시 다른방법으로...
        this.components.push(item);
    }
    
    //queryParams 삭제
    private getCleanUrl(url: string): string {
        return url.replace(/\?(.*)/,'')
    }

    //상세로 가고 있나??
    private isGoToDetail(): boolean {
        let whenSavePath = this.history[this.history.length-1];
        let pathSplit = this.history[this.history.length-1].split('/');
        let prevDepthPath = '';

        if(pathSplit.length==2) {//1Depth 일때
            prevDepthPath = whenSavePath;// /notice
        } else {
            prevDepthPath = whenSavePath.replace(pathSplit[pathSplit.length-1], '');
        }
        let nextPath = this.getCleanUrl(this.router.url);// 다음페이지 URL

        if(nextPath.indexOf(prevDepthPath) < 0) //상세가 아닌 때
            return false;
        else
            return true;
    }
    
    private clear(): void {
        console.log("Restore!초기화!");
        this.history=this.resetHistory();
        this.components=new Array<ComponentByUrl>();
    }

    //히스토리 리스트 URL 만 빼고 초기화
    private resetHistory(): Array<string> {
        return this.history=[this.getCleanUrl(this.router.url)];
    }

    public setRefresh_Param_Key(name: string) {
        console.log(name);
    }
}

class ComponentByUrl {
    url: string;
    _this: any;
    scroll: number;
}